import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Movie(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.648 3a4.204 4.204 0 014.199 4.198 4.18 4.18 0 01-.962 2.671H17c1.103 0 2 .896 2 2v.403l2.654-.845a.999.999 0 011.304.953v6.976a1 1 0 01-1.304.953L19 19.465v.404c0 1.103-.897 2-2 2H3c-1.103 0-2-.897-2-2v-8c0-1.046.807-1.906 1.83-1.993a3.505 3.505 0 01-.633-2.014 3.54 3.54 0 013.537-3.537 3.52 3.52 0 012.257.816A4.197 4.197 0 0111.648 3zM17 11.868H3v8h14.001l-.001-8zm3.958 1.88L19 14.373v2.992l1.958.623v-4.24zM11.648 5A2.2 2.2 0 009.45 7.198a2.2 2.2 0 002.198 2.2 2.202 2.202 0 002.199-2.2A2.201 2.201 0 0011.646 5zM5.734 6.324c-.847 0-1.537.69-1.537 1.537 0 .848.69 1.537 1.537 1.537S7.27 8.708 7.27 7.86c0-.848-.689-1.537-1.536-1.537z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoMovie = React.memo(Movie);
export default MemoMovie;